/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { globals as globalsSlice } from '../../../../app/globalsSlice';
import { me as meSlice } from '../../../AuthenticatedPage/authenticationSlice';
import { details as detailsSlice } from '../../accountSlice';
import { SLICE_NAME } from '../../constants';
import AccountTypeCard from './AccountTypeCard';
import AddressCard from './AddressCard';
import ConfirmUpdateDialog from './ConfirmUpdateDialog';
import ContactInfoCard from './ContactInfoCard';
import UserDetailsCard from './UserDetailsCard';

const ProfileDetails = () => {
    const dispatch = useDispatch();
    const me = useSelector(meSlice);
    const { globals } = useSelector(globalsSlice);
    const ipoName = (globals && globals.ipo && globals.ipo.name) || '';

    const details = useSelector(detailsSlice);

    const [open, setOpen] = useState(false);
    const [updatePayload, setUpdatePayload] = useState(null);

    useEffect(() => {
        const { username } = me;

        if (!details) {
            dispatch({ type: `${SLICE_NAME}/getAccountDetails`, payload: { userName: username } });
        }
    }, [dispatch, details, me]);

    const saveDetails = (payload, fromCard) => {
        setUpdatePayload({ requestBody: payload, fromCard });
        setOpen(true);
    };

    const updateCard = () => {
        if (updatePayload) {
            dispatch({ type: `${SLICE_NAME}/updateAccountDetails`, payload: updatePayload });
        }
        setOpen(false);
    };

    const cancelUpdate = (event) => {
        event.preventDefault();
        setOpen(false);
    };

    const { userType, authorities } = me || {};

    const hasAdministratorRole = userType === 'MAIN' || (authorities || []).includes('ROLE_ACCOUNT_ADMINISTRATOR');

    return (
        <>
            <AccountTypeCard initialValues={(details && details.accountTypeDetails) || {}} />
            <UserDetailsCard initialValues={details || {}} saveDetails={saveDetails} hasAdministratorRole={hasAdministratorRole} />
            <AddressCard initialValues={details || {}} saveDetails={saveDetails} hasAdministratorRole={hasAdministratorRole} />
            <ContactInfoCard initialValues={details || {}} saveDetails={saveDetails} hasAdministratorRole={hasAdministratorRole} />
            <ConfirmUpdateDialog open={open} onAccept={updateCard} onCancel={cancelUpdate} ipoName={ipoName} />
        </>
    );
};

export default ProfileDetails;
